import {Scene} from 'scene';
import {Animation} from 'animation';
import {Sprite, Texture, Sound, soundArray} from './gameutils';
import ToggleButton from './toggle_button';

const BitmapText = PIXI.extras.BitmapText;

const ROWS = 3
const COLS = 5
const SYMBOLS = ROWS * COLS

//is filters usage ON - trying to speed things up:
const FILTERS = true

//is video ON:
const VIDEO = true

const fragment = `
varying vec2 vTextureCoord;
uniform sampler2D uSampler;

uniform float gamma;
uniform float contrast;
uniform float saturation;
uniform float brightness;
uniform float red;
uniform float green;
uniform float blue;
uniform float alpha;

void main(void)
{
    vec4 c = texture2D(uSampler, vTextureCoord);

    if (c.a > 0.0) {
        c.rgb /= c.a;

        vec3 rgb = pow(c.rgb, vec3(1. / gamma));
        rgb = mix(vec3(.5), mix(vec3(dot(vec3(.2125, .7154, .0721), rgb)), rgb, saturation), contrast);
        rgb.r *= red;
        rgb.g *= green;
        rgb.b *= blue;
        c.rgb = rgb * brightness;

        c.rgb *= c.a;
    }

    gl_FragColor = c * alpha;
}`;


/**
 * textStyle
 *
 * @param   {integer}   font_size - размер шрифта
 * @param   {string}    color - цвет текста
 * @param   {bolean}    wordWrap - включить переносы
 * @param   {integer}   wordWrapWidth - ширина текстового блока
 * @return  {object}
 */
const textStyle = (font_size, color, wordWrap = false, wordWrapWidth = 0) => new PIXI.TextStyle({
    fontFamily: 'Arial',
    fontSize: font_size,
    fontStyle: '',
    fontWeight: '',
    fill: color,
    wordWrapWidth: wordWrapWidth,
    wordWrap: wordWrap,
});

const colToRow = [0,3,6,9,12, 1,4,7,10,13, 2,5,8,11,14];

const createSmallTable = () => {
    const table = new PIXI.Container();
    table.addChild(new PIXI.Sprite(PIXI.utils.TextureCache['res/tables/table_small.png']));

    const iSign = new PIXI.Sprite(PIXI.TextureCache['res/tables/i-mini.png']);
    iSign.position.set(26, 54);
    table.addChild(iSign);

    {
        const x_offset = 46;
        const x_indent = 63;
        const y_indent = 51;
        const text_style  = textStyle(16,'#accff9');

        for (let i = 0; i < 5; i++) {
            const col_name = new PIXI.Text('П'+(i+1), text_style);
            col_name.position.set(x_indent + (x_offset * i), y_indent);
            table.addChild(col_name);
        }
    }

    let dividerLabel;
    {
        const text_style = textStyle(12, '#accff9');

        const divider = new PIXI.Text('делитель:', text_style);
        divider.position.set(250, 46);
        divider.anchor.set(1.0);
        table.addChild(divider);

        dividerLabel = new PIXI.Text('1.3', text_style);
        dividerLabel.position.set(15 + 240, 31 + 1);
        table.addChild(dividerLabel);
        dividerLabel.visible = false;
    }

    let dateLabel;
    {
        const text_style = textStyle(12, '#accff9');

        const data_time = new PIXI.Text('дата / время:', text_style);
        data_time.position.set(15, 18);
        table.addChild(data_time);

        dateLabel =  new PIXI.Text('06.02.2018 15:10:15', text_style);
        dateLabel.position.set(15, 31);
        table.addChild(dateLabel);
        dateLabel.visible = false;
    }

    let difficultyLevelLabel;
    {
        const text_style = textStyle(12, '#accff9');

        const difficulty_level = new PIXI.Text('уровень сложности:', text_style);
        difficulty_level.position.set(250, 32);
        difficulty_level.anchor.set(1.0);
        table.addChild(difficulty_level);

        difficultyLevelLabel = new PIXI.Text('3', text_style);
        difficultyLevelLabel.position.set(15 + 240, 31 - 13);
        table.addChild(difficultyLevelLabel);
        difficultyLevelLabel.visible = false;
    }

    const symbolLabels = [],
          numberLabels = [];

    {
        const text_style = textStyle(18,'#accff9', true, 10);
        var symbol_style = textStyle(16,'#ffffff');
        var numb_style = textStyle(12,'#accff9');

        for (let i = 0; i < 3; i++) {
            const time_label = new PIXI.Text(`+${i} сек`, text_style);
            time_label.position.set(18, 75 + i * 45);
            table.addChild(time_label);

            for (let j = 0; j < 5; j++) {
                const txtSymbol = new PIXI.Text('7', symbol_style);
                txtSymbol.position.set(46 * j + 72, i * 45 + 100);
                txtSymbol.anchor.set(0.5);
                txtSymbol.visible = false;
                table.addChild(txtSymbol);
                symbolLabels.push(txtSymbol);

                const txtNumber = new PIXI.Text('12345', numb_style);
                txtNumber.position.set(46 * j + 72, i * 45 + 80);
                txtNumber.anchor.set(0.5);
                txtNumber.visible = false;
                table.addChild(txtNumber);
                numberLabels.push(txtNumber);
            }
        }
    }

    return {
        table,
        symbolLabels,
        numberLabels,
        dateLabel,
        dividerLabel,
        difficultyLevelLabel
    };
};


const createBigTable = () => {

    const table = new PIXI.Container();
    table.addChild(new PIXI.Sprite(PIXI.utils.TextureCache['res/tables/table_big.png']));

    const iSign = new PIXI.Sprite(PIXI.TextureCache['res/tables/i-maxi.png']);
    iSign.position.set(55, 117);
    table.addChild(iSign);

    {
        const x_offset = 100;
        const x_indent = 141;
        const y_indent = 118;
        const text_style  = textStyle(24,'#accff9');

        for (let i = 0; i < 5; i++) {
            const col_name = new PIXI.Text('П'+(i+1), text_style);
            col_name.position.set(x_indent + (x_offset * i), y_indent);
            table.addChild(col_name);
        }
    }

    let dividerLabel;
    {
        const text_style = textStyle(26, '#accff9');

        const divider = new PIXI.Text('делитель:', text_style);
        divider.position.set(549, 78);
        divider.anchor.set(1, 0);
        table.addChild(divider);

        dividerLabel = new PIXI.Text('1.3', text_style);
        dividerLabel.position.set(549, 78);
        table.addChild(dividerLabel);
        dividerLabel.visible = false;
    }

    let dateLabel;
    {
        const text_style = textStyle(26, '#accff9');

        const data_time = new PIXI.Text('дата / время:', text_style);
        data_time.position.set(31, 50);
        table.addChild(data_time);

        dateLabel = new PIXI.Text('06.02.2018 15:10:15', text_style);
        dateLabel.position.set(31, 80);
        table.addChild(dateLabel);
        dateLabel.visible = false;
    }

    let difficultyLevelLabel;
    {
        const text_style = textStyle(26, '#accff9');

        const difficulty_level = new PIXI.Text('уровень сложности:', text_style);
        difficulty_level.position.set(550, 50);
        difficulty_level.anchor.set(1, 0);
        table.addChild(difficulty_level);

        difficultyLevelLabel = new PIXI.Text('3', text_style);
        difficultyLevelLabel.position.set(550, 50);
        table.addChild(difficultyLevelLabel);
        difficultyLevelLabel.visible = false;
    }

    const symbolLabels = [],
          numberLabels = [];

    {
        const text_style = textStyle(24,'#accff9', true, 10);
        var symbol_style = textStyle(22,'#ffffff');
        var numb_style = textStyle(18,'#accff9');

        for (let i = 0; i < 3; i++) {
            const time_label = new PIXI.Text(`+${i} сек`, text_style);
            time_label.position.set(52, 180 + i * 95);
            table.addChild(time_label);

            for (let j = 0; j < 5; j++) {
                const txtSymbol = new PIXI.Text('7', symbol_style);
                txtSymbol.position.set(99 * j + 155, i * 95 + 225);
                txtSymbol.anchor.set(0.5);
                txtSymbol.visible = false;
                table.addChild(txtSymbol);
                symbolLabels.push(txtSymbol);

                const txtNumber = new PIXI.Text('12345', numb_style);
                txtNumber.position.set(99 * j + 155, i * 95 + 185);
                txtNumber.anchor.set(0.5);
                txtNumber.visible = false;
                table.addChild(txtNumber);
                numberLabels.push(txtNumber);
            }
        }
    }

    return {
        table,
        symbolLabels,
        numberLabels,
        dateLabel,
        dividerLabel,
        difficultyLevelLabel
    };
};


let videoLoadedHandler;

export default class MainScene extends Scene {

    constructor (spec, math, space) {
        super();

        //nothing is appearing yet:
        this.appearing = -1
        space.s( "ticker" ).on( seconds => this.try_appear( seconds ) )

        // как перебираются линии и ставки
        this.mathConfig = {
            lines : spec.lines_array,
            multipliers : spec.bets_array,
        };

        this.space = space;

        this.freeGamesMultiplier = spec.freegamesMultiplier;

        this.math = math;

        this.mainBackground = Sprite('res/maingame/background.jpg');
        this.addChild(this.mainBackground);

        this.freeGamesBackground = Sprite('res/freegames/background.jpg');
        this.addChild(this.freeGamesBackground);
        this.freeGamesBackground.visible = false;

        this.logo = Sprite('res/logo.png');
        this.logo.position.set(512, 560);
        this.logo.anchor.set(0.5, 0);
        this.addChild(this.logo);


        // const gui = new dat.GUI();

        this.freeGamesCounterLabel = Sprite('res/freegames/freegames_count.png');
        this.addChild(this.freeGamesCounterLabel);
        this.freeGamesCounterLabel.position.set(220, 580);
        this.freeGamesCounterLabel.visible = false;

        // const folder1 = gui.addFolder('label');
        // folder1.add(this.freeGamesCounterLabel.position, 'x', 100, 300);
        // folder1.add(this.freeGamesCounterLabel.position, 'y', 550, 620);

        this.txtCurrentFreeGameLabel = new BitmapText('9', {font: 'freegame_counter_font'});
        this.freeGamesCounterLabel.addChild(this.txtCurrentFreeGameLabel);
        this.txtCurrentFreeGameLabel.position.set(510, 11);
        this.txtCurrentFreeGameLabel.anchor.set(0.5);

        // const folder2 = gui.addFolder('current');
        // folder2.add(this.txtCurrentFreeGameLabel.position, 'x', 300, 600);
        // folder2.add(this.txtCurrentFreeGameLabel.position, 'y', 0, 20);


        this.txtTotalFreeGameLabel = new BitmapText('10', {font: 'freegame_counter_font'});
        this.freeGamesCounterLabel.addChild(this.txtTotalFreeGameLabel);
        this.txtTotalFreeGameLabel.position.set(600, 11);
        this.txtTotalFreeGameLabel.anchor.set(0.5);

        // const folder3 = gui.addFolder('total');
        // folder3.add(this.txtTotalFreeGameLabel.position, 'x', 300, 600);
        // folder3.add(this.txtTotalFreeGameLabel.position, 'y', 0, 20);

        this.desaturateFilter = new PIXI.Filter(null, fragment);
        this.desaturateFilter.uniforms.gamma = 1.2;
        this.desaturateFilter.uniforms.saturation = 0;
        this.desaturateFilter.uniforms.contrast = 1.5;
        this.desaturateFilter.uniforms.brightness = 1;
        this.desaturateFilter.uniforms.red = 0.6;
        this.desaturateFilter.uniforms.green = 0.8;
        this.desaturateFilter.uniforms.blue = 1.2;
        this.desaturateFilter.uniforms.alpha = 1.0;

        const text_style = textStyle(10,'#ffffff');
        this.smallSymbols = [];
        for (let i = 0; i < math.symbolsNumber(); i++) {
            const symbol = Sprite(`symbol_${i}.png`);
            if ( FILTERS ) symbol.filters = [this.desaturateFilter];
            symbol.width = 48;
            symbol.height = 48;
            this.addChild(symbol);
            symbol.position.set(360 + i * 48, 40);
            this.smallSymbols.push(symbol);

            const billet = Sprite('res/billet.png');
            this.addChild(billet);
            billet.position.set(361 + i * 48, 88);

            const label = new PIXI.Text(`${i}`, text_style);
            label.anchor.set(0.5);
            label.position.set(24, 5);
            billet.addChild(label);
        }

        this.symbolFrames = [];
        for (let i = 0; i < math.symbolsNumber(); i++) {
            const frame = new PIXI.Graphics();
            this.addChild(frame);
            this.symbolFrames.push(frame);
            frame.visible = false;
            frame.position.set(360 + i * 48, 40);
            frame.lineStyle(3, 0xFFFFFF, 1);
            frame.drawRect(-1, -1, 50, 50);
        }


        this.barrelElements = [];
        for (let i = 0; i < 15; i++) {
            const sprite = Sprite('symbol_0.png');
            sprite.visible = false;
            const row = i % 3 | 0;
            const col = i / 3 | 0;
            const x = 370 + 122 * col;
            const y = 116 + 122 * row;
            sprite.position.set(x, y);
            this.addChild(sprite);
            this.barrelElements.push(sprite);
        }

        this.barrelHotArea = new PIXI.Container();
        this.addChild(this.barrelHotArea);
        this.barrelHotArea.hitArea = new PIXI.Rectangle(370, 116, 122 * 5, 122 * 3);
        this.barrelHotArea.interactive = true;
        this.barrelHotArea.buttonMode = true;
        this.barrelHotArea.cursor = 'inherited';
        this.barrelHotArea.on('pointerdown', () => {
            space.s( "barrel:click" ).next();
        });


        this.frameAnimations = [];
        for (let i = 0; i < 5; i++) {
            const animation = Animation.byFrameName('frame_%03d.png', 15);
            animation.loop = true;
            animation.animationSpeed = 0.2;
            animation.visible = false;
            this.addChild(animation);
            this.frameAnimations.push(animation);
        }

        const frame = new PIXI.Graphics();
        frame.position.set(30, 38);
        frame.beginFill(0x8ebce5, 1.0);
        frame.drawRect(0, 0, 294, 240);
        frame.endFill();
        this.addChild(frame);


        const poster = Sprite('res/poster.png');
        poster.position.set(2, 2);
        frame.addChild(poster);

        if ( VIDEO )
        {
            this.videoSprite = new PIXI.Sprite();
            this.videoSprite.position.set(2, 2);
            this.videoSprite.width  = 290;
            this.videoSprite.height = 236;
            frame.addChild(this.videoSprite);
        }

        this.zoomInVideoButton = Sprite('res/tables/buttons/maximize.png');
        frame.addChild(this.zoomInVideoButton);
        this.zoomInVideoButton.buttonMode = true;
        this.zoomInVideoButton.cursor = 'pointer';
        this.zoomInVideoButton.interactive = false;
        this.zoomInVideoButton.position.set(280, 225);
        this.zoomInVideoButton.on('pointerdown',  event => {
            if (event.data.originalEvent.button != null && event.data.originalEvent.button === 0) {
                this.bigVideoFrame.visible = true;
            }
        });

        const muteVideoButton = new ToggleButton(Texture('res/tables/buttons/mute_on.png'), Texture('res/tables/buttons/mute_off.png'));
        frame.addChild(muteVideoButton);
        muteVideoButton.position.set(-5, 225);
        muteVideoButton.callback = () => {
            console.log('MUTE');
        };


        const smallTable = createSmallTable();

        // массив лейблов, содержащих значения кодов символов
        this.smallTableSymbols = smallTable.symbolLabels;

        // массив лейблов, содержащих значения каких-то чисел
        this.smallTableNumbers = smallTable.numberLabels;

        this.txtDividerSmall = smallTable.dividerLabel;
        this.txtDateLabelSmall = smallTable.dateLabel;
        this.txtDifficultyLevelSmall = smallTable.difficultyLevelLabel;

        this.smallTable = smallTable.table;

        this.addChild(this.smallTable);
        this.smallTable.position.set(30, 291);

        const zoomTableButton = new ToggleButton(Texture('res/tables/buttons/maximize.png'), Texture('res/tables/buttons/minimize.png'));
        this.smallTable.addChild(zoomTableButton);
        zoomTableButton.position.set(279, 207);
        zoomTableButton.callback = value => {
            this.bigTable.visible = !value;
        };


        const bigTable = createBigTable();

        // массив лейблов, содержащих значения кодов символов
        this.bigTableSymbols = bigTable.symbolLabels;

        // массив лейблов, содержащих значения каких-то чисел
        this.bigTableNumbers = bigTable.numberLabels;

        this.txtDividerBig = bigTable.dividerLabel;
        this.txtDateLabelBig = bigTable.dateLabel;
        this.txtDifficultyLevelBig = bigTable.difficultyLevelLabel;

        this.bigTable = bigTable.table;
        this.bigTable.visible = false;

        this.addChild(this.bigTable);
        this.bigTable.position.set(192, -2);


        if ( VIDEO )
        {
            // увеличенное видео
            this.bigVideoFrame = new PIXI.Graphics();
            this.bigVideoFrame.interactive = true;
            this.bigVideoFrame.buttonMode = true;
            this.bigVideoFrame.cursor = 'inherited';
            this.bigVideoFrame.position.set(164, 5);
            this.bigVideoFrame.beginFill(0x8ebce5, 1.0);
            this.bigVideoFrame.drawRect(0, 0, 696, 516);
            this.bigVideoFrame.endFill();
            this.addChild(this.bigVideoFrame);
            this.bigVideoFrame.visible = false;

            this.bigVideoSprite = new PIXI.Sprite();
            this.bigVideoSprite.position.set(2, 2);
            this.bigVideoSprite.width  = 696 - 4;
            this.bigVideoSprite.height = 516 - 4;
            this.bigVideoFrame.addChild(this.bigVideoSprite);

            this.zoomOutVideoButton = Sprite('res/tables/buttons/minimize.png');
            this.bigVideoFrame.addChild(this.zoomOutVideoButton);
            this.zoomOutVideoButton.buttonMode = true;
            this.zoomOutVideoButton.cursor = 'pointer';
            this.zoomOutVideoButton.interactive = true;
            this.zoomOutVideoButton.position.set(696-15, -5);
            this.zoomOutVideoButton.on('pointerdown',  event => {
                if (event.data.originalEvent.button != null && event.data.originalEvent.button === 0) {
                    this.bigVideoFrame.visible = false;
                }
            });

            const htmlVideo = document.getElementById('innerVideo');

            videoLoadedHandler = () => {
                const videoTexture = PIXI.Texture.fromVideo(htmlVideo);
                this.videoSprite.texture = videoTexture;
                this.bigVideoSprite.texture = videoTexture;
                this.zoomInVideoButton.interactive = true;
            };

            htmlVideo.addEventListener('canplay', videoLoadedHandler);

            // https://developers.google.com/web/updates/2017/06/play-request-was-interrupted
            htmlVideo.src = "http://136.243.152.82:8282";

            const playVideoPromise = htmlVideo.play();

            if (playVideoPromise !== undefined) {
                playVideoPromise.then(() => {
                    this.safeVideoPause = true;
                })
                .catch(error => {

                });
            }
        }


        this.freeGamesStartTable = Sprite('res/freegames/table_start.png');
        this.freeGamesStartTable.visible = false;
        this.addChild(this.freeGamesStartTable);
        this.freeGamesStartTable.position.set((1024-437)/2, (768-193)/2);

        this.pressStartLabel = Sprite('res/freegames/press_start.png');
        this.freeGamesStartTable.addChild(this.pressStartLabel);
        this.pressStartLabel.position.set(218, 150);
        this.pressStartLabel.anchor.set(0.5);

        this.wonFreeGamesLabel = new BitmapText('0', {font: 'freegame_font'});
        this.freeGamesStartTable.addChild(this.wonFreeGamesLabel);
        this.wonFreeGamesLabel.position.set(190, 43);
        this.wonFreeGamesLabel.anchor.set(1, 0);


        this.freeGamesFinishTable = Sprite('res/freegames/table_finish.png');
        this.freeGamesFinishTable.visible = false;
        this.addChild(this.freeGamesFinishTable);
        this.freeGamesFinishTable.position.set((1024-437)/2, (768-193)/2);

        this.pressFinishLabel = Sprite('res/freegames/press_finish.png');
        this.freeGamesFinishTable.addChild(this.pressFinishLabel);
        this.pressFinishLabel.position.set(218, 150);
        this.pressFinishLabel.anchor.set(0.5);

        this.freeGamesTotalWinLabel = new BitmapText('0', {font: 'freegame_font'});
        this.freeGamesFinishTable.addChild(this.freeGamesTotalWinLabel);
        this.freeGamesTotalWinLabel.position.set(437/2, 193/2);
        this.freeGamesTotalWinLabel.anchor.set(0.5);


        this.sndCredits = Sound('credits');

        this.sndBetUp = Sound('bet-up');
        this.sndBetDown = Sound('bet-down');

        this.sndLines = soundArray('lines/lines_%d', 5);

        this.sndFreegamesBegin = Sound('freegames_start');
        this.sndFreegamesBegin.loop(true);

        this.sndFreegamesEnd = Sound('freegames_end');
        this.sndFreegamesEnd.loop(true);

        this.sndFreegamesMusic = Sound('freegames_music');
        this.sndFreegamesMusic.loop(true);
        
        this.$scatters_win_display_step_end = space.s( "gorbunok:scatters_win_display_step_end" )
        this.$scatters_win_display_step_end.on( p => this.scatters_win_display_step_end( p ) )
        
        this.$line_win_display_step_end = space.s( "gorbunok:line_win_display_step_end" )
        this.$line_win_display_step_end.on( p => this.line_win_display_step_end( p ) )

        this.sndWins = soundArray('line_wins/line_%d', 10);
        for ( const s of this.sndWins ) s.on( "end", () => this.$line_win_display_step_end.next() )
        this.sndScattersWin = Sound('scatter_win');
        this.sndScattersWin.on( "end", () => this.$scatters_win_display_step_end.next() )
        this.sndScattersWinFreegames = Sound('scatters_win_freegames');
        this.sndScattersWinFreegames.on( "end", () => this.$scatters_win_display_step_end.next() )

        this.sndScatters = soundArray('scatters/scatter_%d', 5);

        this.sndSymbol = soundArray('fill_symbol_%d', 2);
        for ( const sound of this.sndSymbol ) sound.volume( 0.4 )
    }

    terminate()
    {
        if ( this.hasOwnProperty( "timeId" ) ) {
            clearTimeout( this.timeId )
            delete this.timeId
        }
        
        delete this.winLines
        
        delete this.$scatters_win_display_step_end
        delete this.$line_win_display_step_end

        this.videoSprite.texture = PIXI.Texture.EMPTY;
        delete this.videoSprite
        this.bigVideoSprite.texture = PIXI.Texture.EMPTY;
        delete this.bigVideoSprite

        this.removeChildren();
        this.destroy();

        const htmlVideo = document.getElementById('innerVideo');
        if (this.safeVideoPause) {
            htmlVideo.pause();
        }
        if (videoLoadedHandler) {
            htmlVideo.removeEventListener('canplay', videoLoadedHandler);
        }

        this.barrelHotArea.removeAllListeners();
        delete this.barrelHotArea

        delete this.space
        delete this.math

        delete this.mainBackground

        delete this.freeGamesBackground

        delete this.logo

        delete this.freeGamesCounterLabel
        delete this.txtCurrentFreeGameLabel
        delete this.txtTotalFreeGameLabel

        delete this.desaturateFilter

        delete this.smallSymbols

        delete this.symbolFrames

        delete this.barrelElements

        for ( const animation of this.frameAnimations ) animation.stop()
        delete this.frameAnimations

        delete this.smallTableSymbols
        delete this.smallTableNumbers
        delete this.txtDividerSmall
        delete this.txtDateLabelSmall
        delete this.txtDifficultyLevelSmall
        delete this.smallTable

        delete this.bigTableSymbols
        delete this.bigTableNumbers
        delete this.txtDividerBig
        delete this.txtDateLabelBig
        delete this.txtDifficultyLevelBig
        delete this.bigTable

        delete this.bigVideoFrame

        delete this.freeGamesStartTable
        delete this.pressStartLabel

        delete this.wonFreeGamesLabel
        delete this.freeGamesFinishTable
        delete this.pressFinishLabel
        delete this.freeGamesTotalWinLabel


        this.zoomOutVideoButton.removeAllListeners();
        delete this.zoomOutVideoButton
        this.zoomInVideoButton.removeAllListeners();
        delete this.zoomInVideoButton

        delete this.sndCredits
        delete this.sndBetUp
        delete this.sndBetDown
        delete this.sndLines

        this.sndFreegamesBegin.unload()
        delete this.sndFreegamesBegin

        this.sndFreegamesEnd.unload()
        delete this.sndFreegamesEnd

        this.sndFreegamesMusic.unload()
        delete this.sndFreegamesMusic

        for ( const sound of this.sndWins ) sound.unload()
        delete this.sndWins

        this.sndScattersWin.unload()
        delete this.sndScattersWin

        this.sndScattersWinFreegames.unload()
        delete this.sndScattersWinFreegames

        for ( const sound of this.sndScatters ) sound.unload()
        delete this.sndScatters

        delete this.sndSymbol
    }

    showZoomedVideo () {
    }

    hideZoomedVideo () {
    }

    readyForRound () {
        this.barrelElements.forEach( element => element.visible = false );

        this.txtDateLabelSmall.visible = false;
        this.txtDifficultyLevelSmall.visible = false;
        this.txtDividerSmall.visible = false;
        this.smallTableNumbers.forEach( element => element.visible = false );
        this.smallTableSymbols.forEach( element => element.visible = false );

        this.txtDateLabelBig.visible = false;
        this.txtDifficultyLevelBig.visible = false;
        this.txtDividerBig.visible = false;
        this.bigTableNumbers.forEach( element => element.visible = false );
        this.bigTableSymbols.forEach( element => element.visible = false );
    }

    steady (symbols, source) {
        const date = source.created.replace(/\sUTC/gi, '');
        this.txtDateLabelSmall.text = date;
        this.txtDateLabelSmall.visible = true;

        this.txtDifficultyLevelSmall.text = source.description.difficulty;
        this.txtDifficultyLevelSmall.visible = true;

        this.txtDividerSmall.text = source.description.devisor;
        this.txtDividerSmall.visible = true;

        this.txtDateLabelBig.text = date;
        this.txtDateLabelBig.visible = true;

        this.txtDifficultyLevelBig.text = source.description.difficulty;
        this.txtDifficultyLevelBig.visible = true;

        this.txtDividerBig.text = source.description.devisor;
        this.txtDividerBig.visible = true;

        for (let i = 0; i < 15; i++) {
            const index = colToRow[i];
            const code = symbols[colToRow[i]];
            const texture = PIXI.TextureCache[`symbol_${code}.png`];
            this.barrelElements[index].texture = texture;
            this.barrelElements[index].visible = true;

            const number = source.description.data[i];

            this.smallTableNumbers[i].visible = true;
            this.smallTableNumbers[i].text = number;

            this.smallTableSymbols[i].visible = true;
            this.smallTableSymbols[i].text = code;

            this.bigTableNumbers[i].visible = true;
            this.bigTableNumbers[i].text = number;

            this.bigTableSymbols[i].visible = true;
            this.bigTableSymbols[i].text = code;
        }
    }

    /**
     * показывает символ на барабане
     * @param  {Numaber} i последовательно возрастающий индекс от 0 до 14
     */
    showSymbol( i )
    {
        // если последний символ, то конец!!!
        if ( i >= SYMBOLS ) {
            this.appearing = -1
            if ( FILTERS ) for ( const smallSymbol of this.smallSymbols ) smallSymbol.filters = [ this.desaturateFilter ]

            for ( const frame of this.symbolFrames ) frame.visible = false

            this.space.s( "barrel:stop" ).next()
            return
        }

        const index = colToRow[i];
        const row = index % ROWS | 0;
        const col = index / ROWS | 0;
        const code = this.symbols[index];
        // console.log(`symbol ${code} row: ${row} column: ${col}`);
        const texture = PIXI.TextureCache[`symbol_${code}.png`];
        this.barrelElements[index].texture = texture;
        this.barrelElements[index].visible = true;

        // озвучиваем скаттеры, если есть
        if (code === this.math.scatter) {
            if (i < 13 || (i == 13 && this.previousScattersCount == 1) || (i == 14 && this.previousScattersCount == 2)) {
                this.sndScatters[ this.previousScattersCount ].play()
            }
            else {
                this.sndSymbol[i % 2].play();
            }
            ++ this.previousScattersCount
        }
        // иначе обычный звук
        else {
            this.sndSymbol[i % 2].play();
        }

        // заполняем ряд сразу
        if (col === 0) {
            const colorfulSymbols = [];

            for (let j = 0; j < 5; j++) {
                const symbol = this.symbols[j * 3 + row];
                const number = this.source.description.data[row * 5 + j];

                colorfulSymbols.push(symbol);

                // в таблице данные построчно
                const k = j + row * 5;

                this.smallTableNumbers[k].visible = true;
                this.smallTableNumbers[k].text = number;

                this.smallTableSymbols[k].visible = true;
                this.smallTableSymbols[k].text = symbol;

                this.bigTableNumbers[k].visible = true;
                this.bigTableNumbers[k].text = number;

                this.bigTableSymbols[k].visible = true;
                this.bigTableSymbols[k].text = symbol;
            }

            // показываем в цвете все коды символов на этом ряду

            for ( const frame of this.symbolFrames ) frame.visible = false

            if ( FILTERS ) for ( const smallSymbol of this.smallSymbols ) smallSymbol.filters = [ this.desaturateFilter ]

            for ( const i of colorfulSymbols )
            {
                if ( FILTERS ) this.smallSymbols[ i ].filters = null
                this.symbolFrames[ i ].visible = true
            }
        }


        if (col < 4) { // если не последний столбец барабана
            //если до конца строки не будет больше символов с таким кодом - скрываем подсветку символа
            const remainedSymbols = [];

            for (let j = col + 1; j < 5; j++) {
                remainedSymbols.push( this.symbols[ j * 3 + row ] )
            }
            // если до конца строки символ больше не встречается
            if ( ! remainedSymbols.includes( code ) ) {
                // гасим его
                if ( FILTERS ) this.smallSymbols[ code ].filters = [ this.desaturateFilter ]
                this.symbolFrames[code].visible = false;
            }
        }
        // явно скрываем подсветку символа
        else {
            if ( FILTERS ) this.smallSymbols[code].filters = [this.desaturateFilter];
            this.symbolFrames[code].visible = false;
        }
    }

    rotate (symbols, source) {
        this.symbols = symbols
        this.source = source

        const date = source.created.replace(/\sUTC/gi, '');
        this.txtDateLabelSmall.text = date;
        this.txtDateLabelSmall.visible = true;

        this.txtDifficultyLevelSmall.text = source.description.difficulty;
        this.txtDifficultyLevelSmall.visible = true;

        this.txtDividerSmall.text = source.description.devisor;
        this.txtDividerSmall.visible = true;

        this.txtDateLabelBig.text = date;
        this.txtDateLabelBig.visible = true;

        this.txtDifficultyLevelBig.text = source.description.difficulty;
        this.txtDifficultyLevelBig.visible = true;

        this.txtDividerBig.text = source.description.devisor;
        this.txtDividerBig.visible = true;

        this.previousScattersCount = 0

        //scheduling the symbols falling process where each symbol will consume some time:
        this.appearing = 0
        this.appeared = 1
        //displaying the first symbol right away:
        this.showSymbol( this.appeared - 1 )
    }

    try_appear( seconds )
    {
        //if not even appearing process then nothing to do:
        if ( this.appearing < 0 ) return

        this.appearing += seconds

        //how much next symbol needs time before appearing:
        let need = 0.2
        if ( this.appeared % COLS == 0 ) need = 0.5
        //if not elapsed enaugh time yet to show next symbol:
        if ( this.appearing < need ) return
        this.appearing -= need
        ++ this.appeared
        this.showSymbol( this.appeared - 1 )
    }

    showFrames( positions )
    {
        for ( const i in positions )
        {
            const index = positions[ i ]
            const row = index % ROWS | 0;
            const col = index / ROWS | 0;
            const x = 370 + 122 * col;
            const y = 116 + 122 * row;
            const frame = this.frameAnimations[i];
            frame.position.set(x, y);
            frame.visible = true;
            frame.gotoAndPlay(0);
        }
    }

    hideFrames() {
        for ( const frame of this.frameAnimations )
        {
            frame.visible = false
            frame.stop()
        }
    }
    
    line_win_display_step_end( currentIndex )
    {
        // если не последняя линия показана
        if ( this.line_win_display_index < this.winLines.length - 1 ) {
            this.hideFrames();
            // показываем следующую
            ++ this.line_win_display_index
            this.showLineWin()
        }
        // иначе последняя
        else {
            // есть ли скаттеры, которые показывают обычно после линий
            if ( this.math.scatterWin() )
            {
                this.hideFrames();
                this.showScattersWin();
            }
            else {
                if ( this.next ) {
                    this.hideFrames()
                    
                    this.to_next()
                }
                else {
                    this.first_time_display = false

                    // только если линий больше чем 1, то начинается новый цикл показа
                    if ( this.winLines.length > 1 ) {
                        this.hideFrames()
                        
                        this.line_win_display_index = 0
                        this.showLineWin()
                    }
                    // иначе рамки одной выигрышной линиии остаются гореть пока не прервут показ выигрыша
                }
            }
        }
    }

    showLineWin()
    {
        const lineNumber = this.winLines[ this.line_win_display_index ]

        this.showFrames( this.math.lineWinPositions( lineNumber ) )

        if ( this.first_time_display ) {
            this.sndWins[ lineNumber ].play()
        }
        else {
            this.timeId = setTimeout( () => this.$line_win_display_step_end.next(), 1000 )
        }
    }
    
    to_next()
    {
        const before_freegames = this.before_freegames
        delete this.before_freegames
        const free = this.free
        delete this.free
        
        if ( before_freegames )
        {
            this.showFreeGamesTable( this.info, free )
        }
        
        const next = this.next
        delete this.next
        next()
    }
    
    scatters_win_display_step_end()
    {
        if ( this.next ) {
            this.hideFrames()
            this.to_next()
        }
        else {
            this.first_time_display = false

            // только если линий больше чем 1, то начинается новый цикл показа
            if ( this.winLines.length > 1 )
            {
                this.hideFrames()
                
                this.line_win_display_index = 0
                this.showLineWin()
            }
            // иначе рамки одной выигрышной линиии остаются гореть пока не прервут показ выигрыша
        }
    }
        
    showScattersWin()
    {
        this.showFrames( this.math.scatterPositions() )
        
        if ( this.math.scatterPositions().length > 2 ) {
            this.sndScattersWinFreegames.play()
        }
        else {
            if ( this.first_time_scatters_win ) {
                this.first_time_scatters_win = false
                this.sndScattersWin.play()
            }
            else {
                this.timeId = setTimeout( () => this.$scatters_win_display_step_end.next(), 1000 )
            }
        }
    }
    
    _showWin()
    {
        this.winLines = []

        this.first_time_display = true
        this.first_time_scatters_win = true

        for (let i = 0; i < this.math.lines; i++) {
            const lineWin = this.math.lineWin(i);
            if (lineWin) {
                this.winLines.push(i);
                console.log(`line ${i} wins ${lineWin}`);
            }
        }
        
        if ( this.winLines.length > 0 ) {
            this.line_win_display_index = 0
            this.showLineWin()
        }
        else if ( this.math.scatterWin() ) {
            this.showScattersWin()
        }
    }
    
    /**
     * инициация показа выигрыша в обычной игре
     * {Object} info - данные: stage.math от сервера, bet - ставка и линии
     * */
    showWin( info ) {
        this.info = info
        this.math.spin( info.math.symbols, info.bet.lines, info.bet.multiplier )
        delete this.next
        this._showWin()
    }

    freeShowWin( info, done ) {
        this.info = info
        this.math.freespin( info.math.symbols, info.bet.lines, info.bet.multiplier, this.freeGamesMultiplier )
        this.flowWin( this.math.win() )
        this.next = done
        this._showWin()
    }

    freeShowWinBeforeFreeGames( info, done ) {
        this.info = info
        this.math.freespin( info.math.symbols, info.bet.lines, info.bet.multiplier, this.freeGamesMultiplier )
        this.flowWin( this.math.win() )
        this.next = done
        this.before_freegames = true
        this.free = true
        this._showWin()
    }

    showWinBeforeFreeGames( info, done ) {
        this.info = info
        this.math.spin( info.math.symbols, info.bet.lines, info.bet.multiplier )
        this.flowWin( this.math.win() )
        this.next = done
        this.before_freegames = true
        this._showWin()
    }

    noFreeWin( info, done ) {
        this.timeId = setTimeout(done, 1000);
    }
    
    interruptShowWin()
    {
        if (this.hasOwnProperty( "timeId" ) ) {
            clearTimeout( this.timeId )
            delete this.timeId
        }

        for ( const sound of this.sndWins ) sound.stop()

        for ( const frame of this.frameAnimations )
        {
            frame.visible = false
            frame.stop()
        }
    }

    freeStartSpin( currentSpin, totalSpins, stageMath )
    {
        if (!this.sndFreegamesMusic.playing()) {
            this.sndFreegamesMusic.play();
        }

        this.logo.visible = false;

        this.freeGamesCounterLabel.visible = true;
        this.txtCurrentFreeGameLabel.text = currentSpin;
        this.txtTotalFreeGameLabel.text = totalSpins;
    }

    showFreeGamesTable( info, isFreegamesRunning )
    {
        if (!isFreegamesRunning) {
            this.sndFreegamesBegin.play();
        }

        this.freeGamesStartTable.visible = true;
        this.freeGamesStartTable.alpha = 0;

        this.wonFreeGamesLabel.text = info.math.freeGamesCountIncrease;

        this.pressStartLabel.visible = false;

        ( new TWEEN.Tween( this.freeGamesStartTable ) )
            .to({alpha: 1}, 200)
            .onComplete(() => {
                if (!isFreegamesRunning) {
                    // this.sndFreegamesBegin.play();

                    this.pressStartLabel.alpha = 1;
                    this.pressStartLabel.visible = true;
                    this.blinkTween = new TWEEN.Tween(this.pressStartLabel)
                        .to({alpha: 0}, 750)
                        .repeat(Infinity)
                        .delay(100)
                        .yoyo(true)
                        .easing(TWEEN.Easing.Cubic.InOut)
                        .start();
                }
                else {
                    this.pressStartLabel.visible = false;
                }
            })
            .start()
    }

    hideFreeGamesTable (done) {

        this.freeGamesStartTable.alpha = 1;

        if (this.blinkTween) {
            this.blinkTween.stop();
            this.blinkTween = null;
        }

        const fadeOutTween = new TWEEN.Tween(this.freeGamesStartTable)
            .to({alpha: 0}, 200)
            .delay(800)
            .onComplete(function () {
                this.freeGamesStartTable.visible = false;
                this.sndFreegamesBegin.stop();
                done();
            }.bind(this))
            .start();
    }

    showFreeGamesFinishTable (info, lines, multiplier, done) {

        console.log('showFreeGamesFinishTable', info);

        this.freeGamesFinishTable.visible = true;
        this.freeGamesFinishTable.alpha = 0;
        //
        // this.freeGamesPlayedLabel.text = `FREE GAMES PLAYED ${info.freeGamesCount}`;
        this.freeGamesTotalWinLabel.text = info.featureWin * multiplier;
        //
        const fadeInTween = new TWEEN.Tween(this.freeGamesFinishTable)
            .to({alpha: 1}, 200)
            .onComplete(() => {

                this.pressFinishLabel.alpha = 1;
                this.pressFinishLabel.visible = true;
                this.blinkTween = new TWEEN.Tween(this.pressFinishLabel)
                    .to({alpha: 0}, 750)
                    .repeat(Infinity)
                    .delay(100)
                    .yoyo(true)
                    .easing(TWEEN.Easing.Cubic.InOut)
                    .start();

                this.sndFreegamesMusic.stop();
                this.sndFreegamesEnd.play();
                setTimeout(done, 0);
            })
            .start();
    }

    hideFreeGamesFinishTable (done) {
        this.freeGamesFinishTable.alpha = 1;

        if (this.blinkTween) {
            this.blinkTween.stop();
            this.blinkTween = null;
        }

        const fadeOutTween = new TWEEN.Tween(this.freeGamesFinishTable)
            .to({alpha: 0}, 200)
            .delay(800)
            .onComplete(function () {
                this.freeGamesFinishTable.visible = false;
                this.sndFreegamesEnd.stop();
                done();
            }.bind(this))
            .start();
    }

    switchToFreeGames (stageMath, done) {

        this.mainBackground.visible = false;
        this.freeGamesBackground.visible = true;

        done();
    }

    switchToMainGame (stageMath, done) {
        this.mainBackground.visible = true;
        this.freeGamesBackground.visible = false;

        this.logo.visible = true;
        this.freeGamesCounterLabel.visible = false;

        this.hideFreeGamesFinishTable(done);
    }

    setWinFlowCallback (cb) {
        this.winFlowCB = cb;
    }

    flowWin (win) {
         if (this.winFlowCB) {
             this.winFlowCB(win);
         }
    }

    freeBarrelDidStop(){}

    creditsDidChange (newValue, oldValue) {
        if (newValue > oldValue) {
            this.sndCredits.play();
        }
    }

    linesDidChange (newValue, oldValue) {
        const lineGroup = this.mathConfig.lines.indexOf(newValue);
        if (lineGroup >= 0) {
            this.sndLines[lineGroup].play();
        }
    }

    multiplierDidChange (newValue, oldValue) {
        if (newValue > oldValue) {
            this.sndBetUp.play();
        }
        else if (newValue < oldValue) {
            this.sndBetDown.play();
        }
    }
}



// WEBPACK FOOTER //
// ./src/mainscene.es6